/* Use this file to add extend the functionality of the theme. */
$(function() {
    if ($('.product__chip.dynamic-variant-button.selected').hasClass('disabled')) {
        $('.btn.klaviyo-bis-trigger').show();
    } else {
        $('.btn.klaviyo-bis-trigger').hide();
    }

    $('#trigger-quickcart').click( e => {
        e.preventDefault();

        $('.quick-cart__wrapper').removeClass('active');
    })

    $('.sizeguide_toggler, .sizeguide_wrapper--close').click(() => {
        if ($('.sizeguide_wrapper').is(':visible')) {
            $('.sizeguide_wrapper').hide();
        } else {
            $('.sizeguide_wrapper').show();
        }
    });

    // Scrolling the window will close the popup
    $(window).scroll(() => {
        if ( window.innerWidth > 768 && $('.sizeguide_wrapper').is(':visible') ) {
            $('.sizeguide_wrapper').hide();
        }
    });

    // Clicks outside the wrapper will close the popup
    $(document).mouseup(e => {
        if (!$('.sizeguide_wrapper').is(e.target) && $('.sizeguide_wrapper').has(e.target).length === 0) {
            $('.sizeguide_wrapper').hide();
        }
    });

    $('.product__chip.dynamic-variant-button').click((e) => {
        console.log("clicked bis!", $(e.currentTarget));
        // If element contains class 'disabled', show klaviyo bis button, otherwise hide it.
        if ($(e.currentTarget).hasClass('disabled')) {
            $('.btn.klaviyo-bis-trigger').show();
        } else {
            $('.btn.klaviyo-bis-trigger').hide();
        }
    });

    // Listen for the product:variant-change event from ProductForm
    document.addEventListener('product:variant-change', function(evt) {
        const variant = evt.detail ? evt.detail.variant : null;
        
        if (!variant || !variant.available) {
            const $klaviyoBtn = $('.btn.klaviyo-bis-trigger');
            
            if ($klaviyoBtn.length) {
                $klaviyoBtn.show();
                
                // Wait a bit for Klaviyo to process the variant change
                setTimeout(() => {
                    // Trigger the click to open Klaviyo modal
                    $klaviyoBtn.trigger('click');
                    if ($klaviyoBtn[0]) {
                        $klaviyoBtn[0].click();
                    }
                }, 200);
            }
        } else {
            $('.btn.klaviyo-bis-trigger').hide();
        }
    });

}); // DOM Loaded
